import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  ECreativeStatus,
  EReportingTimeWindow,
  ETimeBucketType,
  IReportingCreativesChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsCreativesReportChartFilters,
  TDACreativesReportChartFilters,
  TDOOHAdGroupsCreativesReportChartFilters,
  TDOOHCreativesReportChartFilters,
  TPPAdvertiserId,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingCreativesChartV3({
  advertiserId,
  retailerId,
  inventoryType,
  campaignId,
  adGroupId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TDACreativesReportChartFilters
  | TDAAdGroupsCreativesReportChartFilters
  | TDOOHCreativesReportChartFilters
  | TDOOHAdGroupsCreativesReportChartFilters
) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingCreativesChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingCreativesChart_${inventoryType}_${advertiserId}_${retailerId}`

  return useQuery(
    [
      queryKeyName,
      { start: startDate, end: endDate, inventoryType, campaignId, adGroupId },
    ],
    () => {
      return coreAPIV3
        .advertiserReporting()
        .getAdvertiserCreativesReportChartV3(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          campaignId,
          adGroupId,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          aggregationType as ETimeBucketType,
          filterBy,
          filterOperation,
          filterValue,
          name,
          // @ts-expect-error: fix in PORT-2535
          status as ECreativeStatus | undefined
        )
    },
    { suspense, enabled }
  )
}
